import { render, staticRenderFns } from "./setSample.vue?vue&type=template&id=74efb1c0&scoped=true&"
import script from "./setSample.vue?vue&type=script&lang=js&"
export * from "./setSample.vue?vue&type=script&lang=js&"
import style0 from "./setSample.vue?vue&type=style&index=0&id=74efb1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efb1c0",
  null
  
)

export default component.exports